<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
            	<div class="col-12 mt-4 mb-4 redeem-ggc-products">
	            	<h1 class="text-center">GGC Products Redemption</h1>
	            	<div class="col-12 mt-4 mb-4 products-wrapper">
	                    <ul class="products">
	                      <template v-for="product in ggc_products">
	                        <li>
                                <a v-bind:href="'/redeem/ggc-products/'+product.slug">
                                    <img v-bind:src="product.main_image" v-bind:alt="product.name"  v-bind:title="product.name" width="auto" height="196" />
                                </a>
	                            <h4><a v-bind:href="'/redeem/ggc-products/'+product.slug">{{ product.name }}</a></h4>
	                        </li>
	                      </template>
	                    </ul>
	                </div>

				</div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .redeem-ggc-products{
        max-width: 800px;
        margin: 0 auto;
    }
    .redeem-ggc-products .products-wrapper{

    }
    .redeem-ggc-products .products-wrapper .products{
        list-style: none;
        padding: 0;
        margin: 0 auto;
        display: block;
        text-align: center;
        width: 100%;
    }
    .redeem-ggc-products .products-wrapper .products li{
        width: 33.33%;
        border: 1px solid #ccc;
        border-radius: 5px;
        overflow: hidden;
        background-color: #fff;
        display: inline-block
    }
    .redeem-ggc-products .products-wrapper .products li a{
        display: block;
        color: #212529;
    }
    .redeem-ggc-products .products-wrapper .products li a img{
        width: auto;
        height: 200px;
    }
    .redeem-ggc-products .products-wrapper .products li h4{
        display: block;
        margin-top: 10px;
    }
</style>

<script>
	import moment from 'moment'

	export default {
        props: ['products'],
        data: () => ({
            ggc_products: ""
        }), 
        mounted() {

            const products = JSON.parse(this.products);
            this.ggc_products = products;
            //console.log(products);

        },
        methods: {
            redeem: function (orderNumber, page_slug) {

            }
        },
        filters: {
          moment: function (date) {
            return moment(date).format('MMMM D, YYYY h:mm:ss A');
          }
        }
    }


</script>